export default __webpack_public_path__ + "static/media/digital_tr.82535037.png";